import req from "../http";

const employeeDepartment = {
  // 取得 Department
  getEmployeeDepartment(params) {
    return req("get", "/BasicInformation/EmployeeDepartment", params);
  }
};

export default employeeDepartment;